import React from 'react';
import ContentContainer from './ContentContainer';

export default (props) => {
    return (
        <ContentContainer lang={props.lang} selectedLanguage={props.selectedLanguage}>
            {props.children}
        </ContentContainer>
    )
}


// WEBPACK FOOTER //
// ./src/components/content/index.jsx